import React from 'react'
import './dashboard.styles.scss'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import Service from './dashboard.service'
import Dialog from '../../components/dialog/dialog.component'
import Loading from '../../components/loading/loading.component'
import NumberFormat from 'react-number-format'


class Dashboard extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadDashboard()
    }

    getGreeting() {
        const hour = new Date().getHours(); // 0 - 23

        if (hour < 12) {
            return "Good morning";
        } else if (hour < 18) {
            return "Good afternoon";
        } else {
            return "Good evening";
        }
    }

    render() {
        return (
            <>
                {this.state.loading && <Dialog><Loading /></Dialog>}
                <div className="dashboard">
                    <div className="header">
                        <h1>{this.getGreeting()}, {this.props.auth.profile.firstname}!</h1>
                    </div>

                    <div className="financial-stats-grid">

                        <div className="info-card card-wallet">
                            <div className="card-header">
                                <i className="fas fa-wallet card-icon"></i>
                                <span className="card-label">Current Wallet Balance</span>
                            </div>
                            <p className="card-value">₦{<NumberFormat value={this.state.wallet.balance} displayType={'text'} thousandSeparator={true} renderText={value => value} />}</p>
                            <Link className="card-action-button" to="/payment/wallet">
                                <span>Quick Top Up</span>
                                <i className="fas fa-arrow-right"></i>
                            </Link>
                        </div>

                        <div className="info-card card-obligations">
                            <div className="card-header">
                                <i className="fas fa-exclamation-triangle card-icon"></i>
                                <span className="card-label">Outstanding Obligations</span>
                            </div>

                            <p className="card-value">₦{<NumberFormat value={this.state.obligationOutstanding / 100} displayType={'text'} thousandSeparator={true} renderText={value => value} />}</p>
                            <Link className="card-action-button" to="/payment/obligations">
                                <span>View & Pay Now</span>
                                <i className="fas fa-arrow-right"></i>
                            </Link>
                        </div>


                        <div className="info-card card-profile">
                            <div className="card-header">
                                <i className="fas fa-user-check card-icon"></i>
                                <span className="card-label">Profile Completion</span>
                            </div>

                            <p className="card-value">{this.state.memberCompletion}%</p>
                            <Link className="card-action-button" to="/settings/profile">
                                <span>Update Profile</span>
                                <i className="fas fa-arrow-right"></i>
                            </Link>
                        </div>

                    </div>
                    <div className="recent-payments-container">
                        <h2 className="section-header">Recent Transactions</h2>
                        <div className="payments-card">
                            <ul className="payments-list">
                                {
                                    this.state.transactions.map((transaction, key) => <>
                                        <li>
                                            <span className="payment-description">{transaction.description}</span>
                                            <span className="payment-amount">₦{<NumberFormat value={transaction.type === 1 ? transaction.credit : transaction.debit} displayType={'text'} thousandSeparator={true} renderText={value => value} />}</span>
                                        </li>
                                    </>)
                                }
                            </ul>

                            <Link to="payment/transactions" className="view-all-link">View all transactions &rarr;</Link>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Dashboard))
